import { get } from 'lodash';

export function userShowGGBranding(store) {
    if (get(store, 'users.currentUser', null)) {
        return !get(store, 'users.currentUser.brandId', null);
    }
    return false;
}

export default function (store) {
    return !get(store, 'entities.meta.meta.whitelabel.hideGGBranding', true);
}



// WEBPACK FOOTER //
// ./src/helpers/showGGBrandingTheme.js